import React from 'react';

import ContactForm from './ContactForm';
import {
  ContactContainer,
  ContactH1,
  ContactWrapper,
  ContactCard,
  ContactIcon,
  ContactH2,
  ContactP1,
  ContactP2

} from './ContactElements';
import ContactFormV2 from './ContactFormV2';

const Contact = () => {
  <link href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet"/>
  return (
    
    <ContactContainer id='contact'>{/* This might be where the you can center the contact cards  */}
      <ContactH1>Contact Me.</ContactH1>
     
       
        <ContactCard>
        <ContactForm/>
        </ContactCard>
  
    
    </ContactContainer>
  );
};

export default Contact;
